import React from 'react';
import { ContainerWrapper } from '../../ContainerWrapper/ContainerWrapper';
import { BuzzBridgeJobDetails } from '../../BuzzBridge/BuzzBridgeJobDetails';

interface IBuzzInterface {}

const BuzzBridgeJobDetailsContainer: React.FC<IBuzzInterface> = props => {
    return (
        <ContainerWrapper>
            <BuzzBridgeJobDetails />
        </ContainerWrapper>
    );
};

export { BuzzBridgeJobDetailsContainer };
